import { CognitoUserPool, ICognitoUserPoolData } from 'amazon-cognito-identity-js'

/**
 * AWS Cognito User Pool configuration.
 * Retrieves User Pool ID and Client ID from environment variables.
 */
const userPoolIds = process.env.REACT_APP_USER_POOL_ID
const clientIds = process.env.REACT_APP_CLIENT_ID

if (!userPoolIds || !clientIds) {
    throw new Error('User Pool ID or Client ID is missing')
}
/**
 * Cognito User Pool data.
 * @type {ICognitoUserPoolData}
 */
const poolData: ICognitoUserPoolData = {
    UserPoolId: userPoolIds,
    ClientId: clientIds
}
/**
 * AWS Cognito User Pool instance.
 * Used for user authentication and management.
 * @type {CognitoUserPool}
 */
const UserPool = new CognitoUserPool(poolData)

export default UserPool
